import React from "react";
import "./BSC.css";

const BSC = () => {
  return (
    <div className="bsc-page">
      <h1 className="page-title">Bachelor of Science</h1>
      <p className="intro-text">
        The B.Sc. program offers students a comprehensive understanding of
        scientific principles, theories, and practical applications within their
        chosen field of study, preparing them for diverse career paths in
        Science, Technology, Engineering, Mathematics, Healthcare, Research,
        etc. Typically, the duration of a B.Sc. program is 3 years.
      </p>

      {/* First Year */}
      <div className="year-section">
        <h2 className="section-title">First Year B.Sc (F.Y.B.Sc)</h2>
        <div className="semester-container">
          <div className="syllabus-semester">
            <h3>Semester I</h3>
            <ul>
              <li>
                Chemistry (Basics in Physics, Inorganic and Organic Chemistry-I)
              </li>
              <li>Physics (Introduction to Mechanics)</li>
              <li>Mathematics (Algebra-I and Calculus-I)</li>
              <li>Calibration of Glassware and Instruments-I</li>
              <li>Basic Statistical Tools in Chemistry-I</li>
              <li>Indian Constitution</li>
              <li>Communication Skills in English</li>
              <li>Indian Knowledge System</li>
            </ul>
          </div>
          <div className="syllabus-semester">
            <h3>Semester II</h3>
            <ul>
              <li>Basics in Physical, Inorganic and Organic Chemistry-II</li>
              <li>Chemistry Practical-II</li>
              <li>Discrete Mathematics and Calculus-II</li>
              <li>Mathematics Practical-II</li>
              <li>Optics</li>
              <li>Physics Practical-II</li>
              <li>Commercial Analysis of Food Samples</li>
              <li>Data Analysis in Chemistry</li>
              <li>Heritage Sites in India</li>
              <li>लेखन कौशल्य - १ कार्यालयीन लेखन व्यवहार व पत्रव्यवहार</li>
              <li>Introduction to Cultural Activities</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Second Year */}
      <div className="year-section">
        <h2 className="section-title">Second Year B.Sc (S.Y.B.Sc)</h2>
        <div className="semester-container">
          <div className="syllabus-semester">
            <h3>Semester III</h3>
            <ul>
              <li>Foundation Course - Contemporary Issues - III</li>
              <li>To be updated...</li>
            </ul>
          </div>
          <div className="syllabus-semester">
            <h3>Semester IV</h3>
            <ul>
              <li>Physics Paper-I</li>
              <li>Physics Paper-II</li>
              <li>Physics Paper-III</li>
              <li>Physics Practical</li>
              <li>Chemistry Paper-I</li>
              <li>Chemistry Paper-II</li>
              <li>Chemistry Paper-III</li>
              <li>Chemistry Practical</li>
              <li>Foundation Course-IV</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Third Year */}
      <div className="year-section">
        <h2 className="section-title">Third Year B.Sc (T.Y.B.Sc)</h2>
        <div className="semester-container">
          <div className="syllabus-semester">
            <h3>Semester V</h3>
            <ul>
              <li>Chemistry - Analytical Chemistry</li>
              <li>Chemistry - Inorganic Chemistry</li>
              <li>Chemistry - Organic Chemistry</li>
              <li>Chemistry - Physical Chemistry</li>
              <li>
                Elective/Specialization Paper (e.g. Environmental Chemistry,
                Medicinal Chemistry)
              </li>
            </ul>
          </div>
          <div className="syllabus-semester">
            <h3>Semester VI</h3>
            <ul>
              <li>Chemistry - Analytical Chemistry</li>
              <li>Chemistry - Inorganic Chemistry</li>
              <li>Chemistry - Organic Chemistry</li>
              <li>Chemistry - Physical Chemistry</li>
              <li>Drugs and Dyes</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BSC;
